import './SideNavModuleItem.scss';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';
import SideNavModuleChildItem from './SideNavModuleChildItem';
import { MenuItem } from 'common/models/page-config.models';
import { Avatar } from '@progress/kendo-react-layout';
import { useState } from 'react';
import { useCompareUrlWithProjectId } from 'common/hooks/route';

interface SideNavModuleItemProps extends MenuItem {
  displayOnly?: boolean;
  open?: boolean;
  onClick: (item: MenuItem) => void;
  onChildClick: (item: MenuItem) => void;
  expanded?: string;
}

function SideNavModuleItem(props: Readonly<SideNavModuleItemProps>) {
  const { open, onClick, onChildClick, expanded, ...item } = props;
  const [avatarImageError, setAvatarImageError] = useState<boolean>(false);
  const { compareUrl } = useCompareUrlWithProjectId();

  const selected = compareUrl(item.route as string, { includes: true });

  const itemExpanded = expanded === item.id;
  const showChildren =
    open && (itemExpanded || selected) && ((item.children?.length ?? 0) > 0 || item.customChildren);

  return (
    <div
      className={`side-nav-module-item-container ${selected ? 'selected' : ''} ${showChildren ? 'open' : ''} ${props.displayOnly ? 'display-only' : ''}`}
    >
      <ClickableDiv
        className={`side-nav-module-item ${open ? 'open' : ''} ${selected ? 'selected' : ''}`}
        onClick={() => onClick(item)}
      >
        {item.icon && (
          <div className="side-nav-icon">
            <KwelloSvgIcon icon={item.icon} />
          </div>
        )}

        {item.customIcon && (
          <Avatar
            className="sideNav-module-item-icon"
            rounded="full"
            type={item.customIcon && !avatarImageError ? 'image' : 'text'}
          >
            <img
              src={item.customIcon}
              alt={item.text}
              referrerPolicy="no-referrer"
              onError={() => setAvatarImageError(true)}
            />
          </Avatar>
        )}

        <div className={`side-nav-module-item-text ${open ? 'open' : ''}`}>{item.text}</div>

        {item.tag && <span className={`menu-tag ${selected ? 'selected' : ''}`}>{props.tag}</span>}

        {!selected && !item.external && (item.children?.length ?? 0) > 0 && (
          <KwelloSvgIcon
            className="side-nav-module-item-menu-arrow-icon"
            icon={itemExpanded ? KWELLO_ICON.CHEVRON_UP_ICON : KWELLO_ICON.CHEVRON_DOWN_ICON}
          />
        )}
      </ClickableDiv>
      <div className={`side-nav-module-item-children ${showChildren ? 'open' : ''}`}>
        {item?.customChildren && (
          <div className="side-nav-module-item-custom-children">{item.customChildren}</div>
        )}

        {item.children?.map((child) => (
          <SideNavModuleChildItem key={child.id} onClick={() => onChildClick(child)} {...child} />
        ))}
      </div>
    </div>
  );
}

export default SideNavModuleItem;
